import { FunctionComponent } from "react";
import { EditorProps } from "./editor";
import Input from "../components/input";

interface RotationFieldProps extends EditorProps {}

const RotationField: FunctionComponent<RotationFieldProps> = ({ configurator, setConfigurator }) => {
  const rotation = configurator.options.rotation ?? [0, 0, 0];

  return (
    <div className="p-6">
      <div className="font-bold mb-4 text-lg">Rotation</div>
      <div className="flex -m-1">
        {rotation.map((value, i) => (
          <div key={`rotation-input-${i}`} className="flex-grow w-0 p-1">
            <div className="capitalize">{["x", "y", "z"][i]}</div>
            <Input
              className="w-full"
              type="number"
              step={0.01}
              value={value}
              onChange={(e) => {
                let arr = [...rotation];
                arr[i] = +e.target.value;
                setConfigurator((prev) =>
                  !prev ? prev : { ...prev, options: { ...prev.options, rotation: arr as [number, number, number] } }
                );
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default RotationField;
